import { Form } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { GlobalEventLimits, getEventLimitsValidationSchema } from 'components/event_type_edit/event_limits';
import { useGetAvailabilityUserEventLimitsQuery, useUpdateAvailabilityUserEventLimitsMutation } from '../api';
import { FlexContainer } from './styles';
const headerContainerCss = "hfn9tha";
const HeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerContainerCss, props.className)} />;
});
const meetingLimitsContainerIsTabletUpCss = "mxclojv";
const meetingLimitsContainerCss = "mf3zq0d";
const MeetingLimitsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(meetingLimitsContainerCss, {
    [meetingLimitsContainerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const meetingLimitsContentCss = "mk30518";
const MeetingLimitsContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(meetingLimitsContentCss, props.className)} />;
});
export const MeetingLimitsSection = () => {
  const [updateUserEventLimits] = useUpdateAvailabilityUserEventLimitsMutation();
  const {
    data: userEventLimits,
    isLoading
  } = useGetAvailabilityUserEventLimitsQuery();
  const {
    dailyLimit,
    weeklyLimit,
    monthlyLimit
  } = userEventLimits || {};
  const initialValues = {
    dailyLimit: dailyLimit || undefined,
    weeklyLimit: weeklyLimit || undefined,
    monthlyLimit: monthlyLimit || undefined
  };
  const buildPayload = values => ({
    dailyLimit: values.dailyLimit || '',
    weeklyLimit: values.weeklyLimit || '',
    monthlyLimit: values.monthlyLimit || ''
  });
  const onSubmit = values => {
    const payload = buildPayload(values);
    updateUserEventLimits({
      eventLimits: payload
    });
  };
  return <MeetingLimitsContainer>
      <MeetingLimitsContent>
        <FlexContainer>
          <HeaderContainer>
            <TitleText level={3} size="medium">
              {I18n.t('publisher.availability_page.advanced_settings.meeting_limits.title')}
            </TitleText>
          </HeaderContainer>
          <BodyText color="muted" size="medium">
            {I18n.t('publisher.availability_page.advanced_settings.meeting_limits.subheader')}
          </BodyText>
        </FlexContainer>
        {!isLoading && <Form initialValues={initialValues} validationSchema={getEventLimitsValidationSchema} onSubmit={onSubmit}>
            <GlobalEventLimits />
          </Form>}
      </MeetingLimitsContent>
    </MeetingLimitsContainer>;
};

require("./meeting_limits_section.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_limits_section.js");